module.exports = __webpack_public_path__ + "img/4.1e5d9b6f.png";